import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["aria-label", "className", "name", "value", "onRadioChange"];
import { forwardRef, useMemo } from 'react';
import { string, any, func } from 'prop-types';
import { jsx } from 'react/jsx-runtime';
import { useBEM } from '../hooks/useBEM.js';
import { RadioGroupContext, roleNone, menuClass, radioGroupClass } from '../utils/constants.js';
import { stylePropTypes } from '../utils/propTypes.js';
const MenuRadioGroup = /*#__PURE__*/forwardRef(function MenuRadioGroup(_ref, externalRef) {
  let {
      'aria-label': ariaLabel,
      className,
      name,
      value,
      onRadioChange
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const contextValue = useMemo(() => ({
    name,
    value,
    onRadioChange
  }), [name, value, onRadioChange]);
  return /*#__PURE__*/jsx(RadioGroupContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsx("li", {
      role: roleNone,
      children: /*#__PURE__*/jsx("ul", _objectSpread(_objectSpread({
        role: "group",
        "aria-label": ariaLabel || name || 'Radio group'
      }, restProps), {}, {
        ref: externalRef,
        className: useBEM({
          block: menuClass,
          element: radioGroupClass,
          className
        })
      }))
    })
  });
});
process.env.NODE_ENV !== "production" ? MenuRadioGroup.propTypes = _objectSpread(_objectSpread({}, stylePropTypes()), {}, {
  name: string,
  value: any,
  onRadioChange: func
}) : void 0;
export { MenuRadioGroup };